module.exports = __webpack_public_path__ + "img/take_status1.dc9ff032.png";